module.exports = __webpack_public_path__ + "fonts/fa-regular-400.5c674c9.woff2";